import axios from 'axios'

export const axiosInstance = () => {
  const defaultOptions = {
    baseURL: process.env.REACT_APP_BASE_URL,
    method: 'get',
    headers: {
      Accept: '*/*',
      'Content-Type': 'application/json',
    },
  }

  // Create instance
  let instance = axios.create(defaultOptions)

  return instance
}

// axios instance shared by entire application
export default axiosInstance()
